import React, {useEffect, useState} from 'react';
import './ssoLogin.css';
import { useLocale } from "../../contexts/localeContext";
import {getInitialSetupDetails} from "../../services/systemService";
import {useDialog} from "../../components/dialog/DialogContext";
import {TranslationKeys} from "../../contexts/TranslationKeys";
import { getErrorMessage } from '../../services/utilities/ServiceError';
import SsoContainer from "../../containers/sso-container.tsx";
import cloudWelcomeScenery from "../../images/Live-login.jpg";
import welcomeScenery from "../../images/login-pic.jpg";
import {isImproHostedCloud} from "../../constants/license-constants";

const SsoLogin = () => {
    const defaultVersion = "v9999.9999.9999.9999";
    const { setLocale, translate } = useLocale();
    const dialog = useDialog();
    const [cloudImproHosted, setCloudImproHosted] = useState(false);
    const [version, setVersion] = useState(defaultVersion);

    useEffect(() => {
        /**
         * load initial setup details to correctly display login page
         */
        loadInitialSetupDetails();
    }, []); // Empty dependency array ensures this runs only once

    const loadInitialSetupDetails = async () => {
        try {
            const response = await getInitialSetupDetails(translate);
            if (!response.success) {
                dialog.pushInfo({
                    title: translate.byKey(TranslationKeys.info),
                    message: translate.byKey(
                        TranslationKeys.connectionLostToServer,
                    ),
                });
            }
            if (response.buildDetail.languageCode) {
                setLocale(response.buildDetail.languageCode);
            }
            if (response.buildDetail.version) {
                setVersion(response.buildDetail.version);
            }
            setCloudImproHosted(isImproHostedCloud(response.buildDetail.usage));
        } catch (error) {
            setCloudImproHosted(false); // defaults to on-premise
            setLocale("en"); // defaults to english
            setVersion(defaultVersion);
            dialog.pushError({
                title: translate.byKey(TranslationKeys.error),
                message: getErrorMessage(error),
            });
        }
    };

    const getWelcomeImage = () => {
        if (cloudImproHosted) {
            return cloudWelcomeScenery;
        }
        return welcomeScenery;
    }

    return (
        <div className="h-full flex flex-col justify-between">
            <div className="flex flex-row h-full">
                <div className="p-40 flex items-center shadow-r">
                    <SsoContainer/>
                </div>
                <div className="w-full" style={{ maxHeight: 'calc(100vh - 0px)', overflow: 'hidden' }}>
                    <img
                        style={{
                            position: 'relative',
                            left: '7px'
                        }}
                        className="h-full login-background-img"
                        alt="Welcome"
                        src={getWelcomeImage()}/>
                    <div className="tagLineTop">
                        <label className="tagLine1">Convenient</label>
                        <label className="tagLine2">security.</label>
                    </div>

                    <div className="tagLineBottom">
                        <label className="tagLine1">Convenient</label>
                        <label className="tagLine2">control.</label>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default SsoLogin;
